var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../converters/DateConverter";
export class SubmissionDeadline {
  constructor(_data) {
    /**
     */
    __publicField(this, "ClientApprovalDueDate");
    /**
     */
    __publicField(this, "Deadline");
    /**
     */
    __publicField(this, "EstablishmentCountryType");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsEPayment");
    /**
     */
    __publicField(this, "PaymentDueDate");
    /**
     */
    __publicField(this, "PeriodNumber");
    /**
     */
    __publicField(this, "ReturnGenerationDueDate");
    /**
     */
    __publicField(this, "Year");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SubmissionDeadline
     */
    __publicField(this, "$type", "V1.SubmissionDeadlineConfigurations.SubmissionDeadline");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ClientApprovalDueDate = DateConverter.from(_data["ClientApprovalDueDate"]);
      this.Deadline = DateConverter.from(_data["Deadline"]);
      this.EstablishmentCountryType = SubmissionDeadlineEstablishmentCountryType[_data["EstablishmentCountryType"]];
      this.Id = _data["Id"];
      this.IsEPayment = _data["IsEPayment"];
      this.PaymentDueDate = DateConverter.from(_data["PaymentDueDate"]);
      this.PeriodNumber = _data["PeriodNumber"];
      this.ReturnGenerationDueDate = DateConverter.from(_data["ReturnGenerationDueDate"]);
      this.Year = _data["Year"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["ClientApprovalDueDate"] = DateConverter.toUtcDateString(this.ClientApprovalDueDate);
    _data["Deadline"] = DateConverter.toUtcDateString(this.Deadline);
    _data["EstablishmentCountryType"] = SubmissionDeadlineEstablishmentCountryType[this.EstablishmentCountryType];
    _data["Id"] = this.Id;
    _data["IsEPayment"] = this.IsEPayment;
    _data["PaymentDueDate"] = DateConverter.toUtcDateString(this.PaymentDueDate);
    _data["PeriodNumber"] = this.PeriodNumber;
    _data["ReturnGenerationDueDate"] = DateConverter.toUtcDateString(this.ReturnGenerationDueDate);
    _data["Year"] = this.Year;
    return _data;
  }
}
export var SubmissionDeadlineEstablishmentCountryType = /* @__PURE__ */ ((SubmissionDeadlineEstablishmentCountryType2) => {
  SubmissionDeadlineEstablishmentCountryType2["Eu"] = "Eu";
  SubmissionDeadlineEstablishmentCountryType2["NonEu"] = "NonEu";
  return SubmissionDeadlineEstablishmentCountryType2;
})(SubmissionDeadlineEstablishmentCountryType || {});
